export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0x73ab43878997BcDc5d726b7aE76F149ebe9d3AA9",
  capRiskStewardFactory: "0x58898Aa0c361EaC3740dadef99eD4b4d41AC1533",
  edgeFactory: "0xE2Fa51b41D7B41d16ba911e405d86dA7FB3D1c45",
  edgeFactoryPerspective: "0x05cf50742e4457cD7CB2f191c03a61ae95CF3C30",
  escrowedCollateralPerspective: "0x5757C89D418e35EF1a0CE3A06258A1Fc8D3d31b2",
  eulerEarnFactoryPerspective: "0xC7ce91e3fd0cfc81CB0A85c63e590f8265223531",
  eulerEarnGovernedPerspective: "0xD5491C7Da8274016244aF8a0bD3998BCc43e4b24",
  eulerEarnPublicAllocator: "0x0a13C9fc4613Cae202138F4E1C2b9125A20562E8",
  eulerUngoverned0xPerspective: "0x96367505890EF888c0C92E19a9814fa27B461549",
  eulerUngovernedNzxPerspective: "0x2671dA0a4539886cDd4E40096fF1A70b45fc7289",
  evkFactoryPerspective: "0x96070bE9d3dFb045c6C96D35CeCc70Aa2940c756",
  externalVaultRegistry: "0x575fcBb7a9f72F8550E578f8fEed6Ac40e0b3b5C",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xA93Ff8C4CC2Ba56Ee182B70bb07F2C75DA249879",
  feeFlowControllerUtil: "0x974417020092194d5f5119e5879Ef77B8F46B180",
  fixedCyclicalBinaryIRMFactory: "0xb30F5540dd93Fd5569c9638B7bF11A4a926E8D17",
  governedPerspective: "0xda258aB9569d0156B99943aDC4083E542F70a6f1",
  governorAccessControlEmergencyFactory:
    "0x88B049E6e1A3e11306aC437bbedD0077a2859A36",
  irmRegistry: "0x25fDdEae07949101fb4D060b95aB999fcAe547D5",
  kinkIRMFactory: "0xBECb652Fded7024765575165A98Bfe30b7374058",
  kinkyIRMFactory: "0xb6d62828ba6063B9d4fD504A70d6a9B2f24b1918",
  oracleAdapterRegistry: "0x049B9404B9cB8E0A02191e563faEFEAA8D87E619",
  oracleRouterFactory: "0x0135fC2605ff2C89E550C2d4C7d75068A4782B43",
  swapVerifier: "0x392C1570b3Bf29B113944b759cAa9a9282DA12Fe",
  swapper: "0x05Eb1A647265D974a1B0A57206048312604Ac6C3",
  termsOfUseSigner: "0xAD8E191ae4D4F6266BbD1bb248Fa2379c98b5b44",
} as const
